// @flow

import DataLayerEvent from './DataLayerEvent';
import EventNames from '../../../../constants/DataLayer/EventNames';

export default class BrandImpression extends DataLayerEvent {
  validate(): boolean {
    return Array.isArray(this.data.brands);
  }

  dispatch(): void {
    this.push({
      event: EventNames.MEASURE_BRAND_IMPRESSION,
      ecommerce: {
        currencyCode: window.currency,
        impressions: this.data.brands
      }
    });
  }
}
